// just use a single observer for performance reasons, and only
// create if actually required
let singleResizeObserver = undefined;
const observeCallbacks = new Map();
function findAndTriggerResizeCallbacks(resizeEvents) {
    // for every resized element, find and trigger the relevent callback
    resizeEvents.forEach((resizeEvent) => {
        const relevantCallbacks = observeCallbacks.get(resizeEvent.target);
        if (relevantCallbacks) {
            relevantCallbacks.forEach((callback) => callback(resizeEvent));
            return;
        }
        console.warn(`Missing callback for observed resize event target: ${resizeEvent.target}`);
    });
}
function unlisten(element, callback) {
    const existingCallbacksForElement = observeCallbacks.get(element) || [];
    const updatedCallbacksForElement = existingCallbacksForElement.filter((existingCallback) => existingCallback !== callback);
    if (updatedCallbacksForElement.length === 0) {
        observeCallbacks.delete(element);
        singleResizeObserver.unobserve(element);
    }
    else {
        observeCallbacks.set(element, updatedCallbacksForElement);
    }
    if (observeCallbacks.size === 0) {
        // there are no remaining callbacks - disconnect observer
        // and allow it to be garbage collected
        singleResizeObserver.disconnect();
        singleResizeObserver = undefined;
    }
}
export default function listenForResize(element, callback) {
    if (!singleResizeObserver) {
        singleResizeObserver = new ResizeObserver(findAndTriggerResizeCallbacks);
    }
    // register callback and start listening
    const existingCallbacksForElement = observeCallbacks.get(element) || [];
    observeCallbacks.set(element, [...existingCallbacksForElement, callback]);
    singleResizeObserver.observe(element);
    return () => unlisten(element, callback);
}
//# sourceMappingURL=listenForResize.js.map